import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			projectsDetailsInfoColLeftCls: string;
			projectsDetailsInfoColRightCls: string;
		}
	},

	slug: string
}

class Info extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Projects Details Info Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();

		if(this.publicVars.cssId.anim?.projectsDetailsInfoColLeftCls) {
			const infoLeftColCount = document.querySelectorAll(this.publicVars.cssId.anim?.projectsDetailsInfoColLeftCls).length;

			for(let i = 1; i <= infoLeftColCount; i++) {
				scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsDetailsInfoColLeftCls + i,
					'projects_info', { animCls: 'animate__fadeInRight25P', once: true });
			}
		}

		if(this.publicVars.cssId.anim?.projectsDetailsInfoColRightCls) {
			const infoRightColCount = document.querySelectorAll(this.publicVars.cssId.anim?.projectsDetailsInfoColRightCls).length;

			for(let i = 1; i <= infoRightColCount; i++) {
				scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsDetailsInfoColRightCls + i,
					'projects_info', { animCls: 'animate__zoomIn', once: true });
			}
		}

	}

	bind() {
		this.msg('bind');
	}
}

export default Info;